import { useEffect, useState } from "react";
import { Pencil } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { formatTRY } from "@/lib/format";
import ProfileDialog from "@/components/prim/ProfileDialog";
import TierSets from "@/components/prim/TierSets";

const yes = (v) => (v ? "Evet" : "Hayır");

export default function PrimSettings() {
  const [rows, setRows] = useState(null);
  const [sets, setSets] = useState([]);
  const [edit, setEdit] = useState(null);
  const [n, setN] = useState(0);
  useEffect(() => { api.get("/prim/profiles").then(({ data }) => setRows(data)); api.get("/prim/tier-sets").then(({ data }) => setSets(data)); }, [n]);
  if (!rows) return <div className="panel h-40 animate-pulse" />;
  return (
    <div className="space-y-4" data-testid="prim-settings">
      <div className="panel overflow-x-auto">
        <div className="px-3 py-2 border-b text-[12px] font-semibold">Personel Prim Ayarları</div>
        <table className="erp-table text-[12px]" data-testid="prim-profiles-table">
          <thead><tr><th>Personel</th><th>Prim</th><th>Hesaplama Tipi</th><th className="text-right">Oran</th><th>Kademe Tablosu</th><th className="text-right">Gün</th><th className="text-right">Min. Marj</th>
            <th>İade Düş</th><th>Tahsil Edilmemiş</th><th>Vadeli</th><th className="text-right">Aylık Hedef</th><th></th></tr></thead>
          <tbody>{rows.map((r) => { const p = r.profile || {}; return (
            <tr key={r.user_id} data-testid={`prim-profile-row-${r.user_id}`}>
              <td className="font-semibold">{r.name}</td><td>{r.profile ? (p.active ? <span className="text-emerald-700 font-semibold">Aktif</span> : <span className="text-slate-400">Pasif</span>) : "—"}</td>
              <td>{p.method_label || "—"}</td><td className="text-right font-mono">{p.method === "sabit" ? `%${p.rate}` : "—"}</td><td>{p.method === "kademeli" ? p.tier_set_name : "—"}</td>
              <td className="text-right font-mono">{p.calc_day ?? "—"}</td><td className="text-right font-mono">{r.profile ? `%${p.min_margin}` : "—"}</td>
              <td>{r.profile ? yes(p.deduct_returns) : "—"}</td><td>{r.profile ? yes(p.include_uncollected) : "—"}</td><td>{r.profile ? yes(p.include_deferred) : "—"}</td>
              <td className="text-right font-mono">{r.profile ? formatTRY(p.monthly_target) : "—"}</td>
              <td><Button size="sm" variant="ghost" onClick={() => setEdit(r)} data-testid={`prim-profile-edit-${r.user_id}`}><Pencil className="h-3.5 w-3.5" /></Button></td>
            </tr>); })}</tbody>
        </table>
      </div>
      <TierSets sets={sets} onChanged={() => setN(n + 1)} />
      {edit && <ProfileDialog row={edit} sets={sets} onClose={() => setEdit(null)} onDone={() => { setEdit(null); setN(n + 1); }} />}
    </div>
  );
}
